import { render, staticRenderFns } from "./Cabins.vue?vue&type=template&id=a680fe1c&scoped=true"
import script from "./Cabins.vue?vue&type=script&lang=js"
export * from "./Cabins.vue?vue&type=script&lang=js"
import style0 from "./Cabins.vue?vue&type=style&index=0&id=a680fe1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a680fe1c",
  null
  
)

export default component.exports